<template>
  <div>
    <div class="bg-white rounded-lg shadow-md overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 p-6  px-6 py-4 text-white">
        <h1 class="text-2xl font-bold">گزارشات استخراج شده پستی</h1>
        <p class="text-blue-100 mt-1">لیست تمام گزارشات در انتظار تایین وضعیت</p>
      </div>

      <!-- Table -->
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              نام گزارش
            </th>
            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              تاریخ
            </th>
            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
               آیتم‌ها بدون وضعیت
            </th>
            <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              تاریخ ایجاد
            </th>
          </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
          <tr
              v-for="report in reports"
              :key="report.id"
              @click="showReportDetails(report)"
              class="cursor-pointer hover:bg-blue-50 transition-colors"
          >
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="flex items-center">
                <div class="ml-4">
                  <div class="text-sm font-medium text-gray-900">{{ report.name }}</div>
                </div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="text-sm text-gray-900">{{ formatDate(report.date) }}</div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                  {{ report.items_count }} آیتم
                </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
              {{ formatDateTime(report.created_at) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
        <div class="flex-1 flex justify-between sm:hidden">
          <button class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
            قبلی
          </button>
          <button class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
            بعدی
          </button>
        </div>
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              نمایش
              <span class="font-medium">{{ from }}</span>
              تا
              <span class="font-medium">{{ to }}</span>
              از
              <span class="font-medium">{{ total }}</span>
              نتیجه
            </p>
          </div>
          <div>
            <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
              <button
                  v-for="page in pages"
                  :key="page"
                  @click="goToPage(page)"
                  :class="[currentPage === page ? 'bg-blue-50 border-blue-500 text-blue-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50', 'relative inline-flex items-center px-4 py-2 border text-sm font-medium']"
              >
                {{ page }}
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <extracted-post-report-details
        v-if="selectedReport"
        :report="selectedReport"
        @close="selectedReport = null"
    />
  </div>
</template>

<script>

import ExtractedPostReportDetails from "@/modules/order_admin/ExtractedPostReportDetails";
export default {
  name: 'ExtractedPostReportList.vue',
  components: {
    ExtractedPostReportDetails
  },
  data() {
    return {
      reports: [],
      selectedReport: null,
      currentPage: 0,
      perPage: 10,
      total: 0,
      loading: false
    };
  },
  computed: {
    pages() {
      return Math.ceil(this.total / this.perPage);
    },
    from() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    to() {
      return Math.min(this.currentPage * this.perPage, this.total);
    }
  },
  created() {
    this.fetchReports();
  },
  methods: {
    fetchReports() {
      this.loading = true;
      this.request({
        url: this.endpoint('file_handler/extractedPostReport/all'),
        params: {
          offset: this.currentPage,
          limit: this.perPage
        },
        method: "get",
        success: data => {
          this.isLoading = false
          this.reports = data.results;
          this.total = data.count;
          this.loading = false
        }
      })
    },
    showReportDetails(report) {
      this.selectedReport = report;
    },
    goToPage(page) {
      if (page !== this.currentPage) {
        this.currentPage = page;
        this.fetchReports();
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('fa-IR', options);
    },
    formatDateTime(dateTimeString) {
      const date = new Date(dateTimeString);
      return date.toLocaleString('fa-IR');
    }
  }
};
</script>